export default __webpack_public_path__ + "6c02611a081d2983e0e9df22b3232817.mov";